import React from 'react'

import type { DnsRecord } from '@fourthwall/services/dist/DnsApiClient'

import { getErrorTooltipText } from '../../utils/getErrorTooltipText'
import { DnsRecordCodeCell } from '../DnsRecordCodeCell/DnsRecordCodeCell'
import { DnsRecordStatusCell } from '../DnsRecordStatusCell/DnsRecordStatusCell'
import { DnsRecordValueCell } from '../DnsRecordValueCell/DnsRecordValueCell'
import * as S from './DnsRecordListItem.styled'

export type DnsRecordListItemProps = {
  record: DnsRecord
}

export const DnsRecordListItem = ({ record }: DnsRecordListItemProps) => (
  <S.Container>
    <S.Main>
      <S.RecordValues>
        <S.Group>
          <S.Label>Type</S.Label>
          <S.Type>{record.recordType}</S.Type>
        </S.Group>

        <S.Group>
          <S.Label>Host</S.Label>
          <DnsRecordCodeCell value={record.zoneFile?.hostLabel || ''} recordAlias={record.alias} />
        </S.Group>

        <S.Group>
          <S.Label>Value</S.Label>
          <DnsRecordValueCell record={record} />
        </S.Group>
      </S.RecordValues>
      <DnsRecordStatusCell record={record} isVerificationInProgress={false} />
    </S.Main>
    {record.lookupValidationError && <S.Error>{getErrorTooltipText(record)}</S.Error>}
  </S.Container>
)
